import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SERVICES_CONSTANTS } from '../utils/constants';
import { StringUtils } from '../utils/stringUtils';
import { ApiResponse } from '../model/auth/api-response';
import { FinanceDashboardDTO } from '../model/finance-dashboard-dto';

@Injectable({
  providedIn: 'root'
})
export class FinanceService {
  private baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private stringUtils: StringUtils
  ) {}

  /**
   * Obtener el dashboard financiero: totales históricos, desglose mensual (6 meses),
   * por categoría/subcategoría y por método de pago.
   * from/to (formato 'yyyy-MM-dd') son opcionales y filtran jobsCount, avgTicket,
   * byCategory y byPaymentMethod. Los totales históricos no se ven afectados por el filtro.
   */
  getDashboard(from?: string, to?: string): Observable<ApiResponse<FinanceDashboardDTO>> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.FINANCES.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.FINANCES.DASHBOARD
    );

    let params = new HttpParams();
    if (from) {
      params = params.set('from', from);
    }
    if (to) {
      params = params.set('to', to);
    }

    return this.http.get<ApiResponse<FinanceDashboardDTO>>(url, { params });
  }
}
